import latinize from 'latinize';

export const parameterize = (string: string, delimiter = '-'): string => {
  const stripped = latinize(string);

  return (
    stripped
      // remove unneeded chars
      .replace(/[^-\w\s\u4E00-\u9FA5]/g, '')
      // trim leading/trailing spaces
      .replace(/^\s+|\s+$/g, '')
      // remove multiple spaces
      .replace(/[\s]+/g, ' ')
      // convert spaces to hyphens
      .replace(/[-\s]/g, delimiter)
      .toLowerCase()
  );
};
